import onGetAllocationTeamMembers from './onGetAllocationTeamMembers';
import onGetActTeamMembers from './onGetActTeamMembers';
import onGetActTeamMember from './onGetActTeamMember';
import onUnlockTeamMember from './onUnlockTeamMember';
import onActivateTeamMember from './onActivateTeamMember';
import onRestoreTeamMember from './onRestoreTeamMember';
import onAssignTeamMember from './onAssignTeamMember';
import onUnAssignTeamMember from './onUnAssignTeamMember';
import onDeactivateTeamMember from './onDeactivateTeamMember';
import onGetAvailableActTeamMembers from './onGetAvailableActTeamMembers';
import onGetAvailableTeamMembers from './onGetAvailableTeamMembers';
import onArchiveTeamMember from './onArchiveTeamMember';
import onGetClinicMembers from './onGetClinicMembers';
// global user
import onCreateGlobalUser from './onCreateGlobalUser';
import onUnlockGlobalUser from './onUnlockGlobalUser';
import onActivateGlobalUser from './onActivateGlobalUser';
import onRestoreGlobalUser from './onRestoreGlobalUser';
import onArchiveGlobalUser from './onArchiveGlobalUser';
import onDeactivateGlobalUser from './onDeactivateGlobalUser';
import onResendInvitationGlobalUser from './onResendInvitationGlobalUser';

export default {
  onGetAllocationTeamMembers,
  onGetActTeamMembers,
  onGetActTeamMember,
  onUnlockTeamMember,
  onAssignTeamMember,
  onUnAssignTeamMember,
  onActivateTeamMember,
  onRestoreTeamMember,
  onDeactivateTeamMember,
  onGetAvailableActTeamMembers,
  onGetAvailableTeamMembers,
  onArchiveTeamMember,
  onGetClinicMembers,
  // global user
  onCreateGlobalUser,
  onUnlockGlobalUser,
  onActivateGlobalUser,
  onArchiveGlobalUser,
  onDeactivateGlobalUser,
  onResendInvitationGlobalUser,
  onRestoreGlobalUser,
};
